/* =============================================================================
   Fear& custom theme — vanilla JavaScript, no dependencies.
   Modules: drawers, dropdowns, accordions, modals, quantity steppers, product form
   (variant selection + AJAX add to cart), gallery, sticky add-to-cart, cart page,
   product recommendations, account helpers.
   Server-rendered markup is fetched from Shopify (Cart API "sections" + Section Rendering API)
   so no HTML is templated in JavaScript.
   ============================================================================= */
(function () {
  'use strict';

  var config = (function () {
    try { return JSON.parse(document.getElementById('theme-config').textContent); } catch (e) { return {}; }
  })();
  config.cartUrl = config.cartUrl || '/cart';
  config.cartAddUrl = config.cartAddUrl || '/cart/add';
  config.cartChangeUrl = config.cartChangeUrl || '/cart/change';
  config.cartUpdateUrl = config.cartUpdateUrl || '/cart/update';
  config.recommendationsUrl = config.recommendationsUrl || '/recommendations/products';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  // Maps cart API error responses to the theme's own wording.
  function friendlyCartError(json, fallback) {
    var text = json && (json.description || json.message);
    if (typeof text !== 'string') text = '';
    if (/^Limited to/.test(text)) return text;
    if (/availab|only \d|all \d|sold out|stock|inventory|can't add|cannot add/i.test(text)) {
      return 'That quantity is not available right now.';
    }
    return fallback;
  }

  function trapFocus(container, event) {
    var focusable = $$(FOCUSABLE, container).filter(function (el) { return el.offsetParent !== null; });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  /* ---------- Overlay manager (drawers + modals share open/close/focus logic) ---------- */
  var Overlay = {
    stack: [],
    open: function (el, opener, bodyClass) {
      if (!el || el.classList.contains('is-open')) return;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.body.classList.add(bodyClass);
      if (opener) opener.setAttribute('aria-expanded', 'true');
      var entry = { el: el, opener: opener || document.activeElement, bodyClass: bodyClass };
      this.stack.push(entry);
      var panel = $('[role="dialog"]', el) || el;
      window.setTimeout(function () {
        var autofocus = $('[data-autofocus]', panel) || $(FOCUSABLE, panel) || panel;
        autofocus.focus({ preventScroll: true });
      }, 50);
    },
    close: function (el) {
      var index = -1;
      for (var i = this.stack.length - 1; i >= 0; i--) { if (this.stack[i].el === el) { index = i; break; } }
      if (index === -1) return;
      var entry = this.stack.splice(index, 1)[0];
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      if (entry.opener && entry.opener.setAttribute) entry.opener.setAttribute('aria-expanded', 'false');
      var stillUsingClass = this.stack.some(function (e) { return e.bodyClass === entry.bodyClass; });
      if (!stillUsingClass) document.body.classList.remove(entry.bodyClass);
      if (entry.opener && entry.opener.focus) entry.opener.focus({ preventScroll: true });
    },
    closeTop: function () {
      if (this.stack.length) this.close(this.stack[this.stack.length - 1].el);
    },
    top: function () {
      return this.stack.length ? this.stack[this.stack.length - 1].el : null;
    }
  };

  function initOverlays() {
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-drawer-open], [data-modal-open]');
      if (opener) {
        event.preventDefault();
        var isDrawer = opener.hasAttribute('data-drawer-open');
        var id = isDrawer ? opener.getAttribute('data-drawer-open') : opener.getAttribute('data-modal-open');
        var target = $(isDrawer ? '[data-drawer="' + id + '"]' : '[data-modal="' + id + '"]');
        Overlay.open(target, opener, isDrawer ? 'drawer-open' : 'modal-open');
        return;
      }
      var closer = event.target.closest('[data-drawer-close], [data-modal-close]');
      if (closer) {
        event.preventDefault();
        var overlay = closer.closest('[data-drawer], [data-modal]');
        if (overlay) Overlay.close(overlay);
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        var openDropdown = $('.dropdown.is-open');
        if (openDropdown) { Dropdown.close(openDropdown); return; }
        Overlay.closeTop();
      } else if (event.key === 'Tab') {
        var top = Overlay.top();
        if (top) trapFocus($('[role="dialog"]', top) || top, event);
      }
    });
  }

  /* ---------- Dropdowns (currency / language) ---------- */
  var Dropdown = {
    toggle: function (dropdown) {
      dropdown.classList.contains('is-open') ? this.close(dropdown) : this.open(dropdown);
    },
    open: function (dropdown) {
      $$('.dropdown.is-open').forEach(function (other) { if (other !== dropdown) Dropdown.close(other); });
      dropdown.classList.add('is-open');
      var trigger = $('[data-dropdown-trigger]', dropdown);
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    },
    close: function (dropdown) {
      dropdown.classList.remove('is-open');
      var trigger = $('[data-dropdown-trigger]', dropdown);
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
  };

  function initDropdowns() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-dropdown-trigger]');
      if (trigger) {
        event.preventDefault();
        Dropdown.toggle(trigger.closest('[data-dropdown]'));
        return;
      }
      if (!event.target.closest('[data-dropdown]')) {
        $$('.dropdown.is-open').forEach(function (d) { Dropdown.close(d); });
      }
    });
    // A localization choice submits its form: show a busy state while Shopify redirects.
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (form.classList.contains('localization')) form.classList.add('is-loading');
    });
  }

  /* ---------- Accordions ---------- */
  function initAccordions() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-accordion-trigger]');
      if (!trigger) return;
      var content = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!content) return;
      var expanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!expanded));
      content.hidden = expanded;
    });
  }

  /* ---------- Generic show/hide toggles (account pages) ---------- */
  function initToggles() {
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-toggle]');
      if (!toggle) return;
      var target = document.getElementById(toggle.getAttribute('data-toggle'));
      if (!target) return;
      var willShow = target.hidden;
      target.hidden = !willShow;
      $$('[data-toggle="' + toggle.getAttribute('data-toggle') + '"]').forEach(function (t) {
        if (t.hasAttribute('aria-controls')) t.setAttribute('aria-expanded', String(willShow));
      });
      if (willShow) {
        var focusTarget = $(FOCUSABLE, target);
        if (focusTarget) focusTarget.focus({ preventScroll: false });
      }
    });
    // Login page: after the "reset password" form posts, Shopify reloads the page — keep that panel visible.
    var recoverPanel = document.getElementById('recover');
    if (recoverPanel && $('.form-message', recoverPanel)) {
      $$('[data-account-panel]').forEach(function (panel) { panel.hidden = panel !== recoverPanel; });
    }
    document.addEventListener('click', function (event) {
      var panelLink = event.target.closest('[data-panel-open]');
      if (!panelLink) return;
      event.preventDefault();
      var id = panelLink.getAttribute('data-panel-open');
      $$('[data-account-panel]').forEach(function (panel) { panel.hidden = panel.id !== id; });
      var panel = document.getElementById(id);
      var first = panel && $(FOCUSABLE, panel);
      if (first) first.focus();
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQuantity() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
      if (!button) return;
      var wrapper = button.closest('[data-quantity]');
      var input = $('[data-quantity-input]', wrapper);
      if (!input) return;
      var min = input.min !== '' ? parseInt(input.min, 10) : 0;
      var max = input.max !== '' ? parseInt(input.max, 10) : Infinity;
      var value = parseInt(input.value, 10);
      if (isNaN(value)) value = min;
      value += button.hasAttribute('data-quantity-plus') ? 1 : -1;
      value = Math.max(min, Math.min(max, value));
      if (String(value) === input.value) return;
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Cart helpers ---------- */
  var Cart = {
    applySections: function (sections) {
      if (!sections) return;
      if (sections['cart-count']) {
        var freshCount = $('[data-cart-count]', parseHTML(sections['cart-count']));
        if (freshCount) $$('[data-cart-count]').forEach(function (el) { el.replaceWith(freshCount.cloneNode(true)); });
      }
      if (sections['cart-drawer']) {
        var freshDrawer = $('[data-cart-drawer-content]', parseHTML(sections['cart-drawer']));
        var currentDrawer = $('[data-cart-drawer-content]');
        if (freshDrawer && currentDrawer) currentDrawer.innerHTML = freshDrawer.innerHTML;
      }
      if (sections['cart-items']) {
        var freshItems = $('[data-cart-items]', parseHTML(sections['cart-items']));
        var currentItems = $('[data-cart-items]');
        if (freshItems && currentItems) currentItems.replaceWith(freshItems);
      }
    },
    openDrawer: function (variantId) {
      var content = $('[data-cart-drawer-content]');
      if (!content) return;
      var items = $$('[data-drawer-item]', content);
      var target = null;
      items.forEach(function (item) { if (item.getAttribute('data-variant-id') === String(variantId)) target = item; });
      if (!target) target = items[0];
      items.forEach(function (item) { item.hidden = item !== target; });
      Recommendations.load(content);
      Overlay.open($('[data-drawer="cart-drawer"]'), null, 'drawer-open');
    },
    refreshSections: function (names) {
      return fetch(window.location.pathname + '?sections=' + names.join(','), { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (sections) { Cart.applySections(sections); })
        .catch(function () {});
    },
    // Units of a product (all variants together) currently in the cart, read from the cart drawer
    // markup, which Shopify re-renders on every cart change.
    productQuantity: function (productId) {
      var total = 0;
      $$('[data-drawer-item][data-product-id="' + productId + '"]').forEach(function (item) {
        total += parseInt(item.getAttribute('data-quantity'), 10) || 0;
      });
      return total;
    },
    change: function (payload, sections) {
      payload.sections = sections || 'cart-drawer,cart-count,cart-items';
      payload.sections_url = window.location.pathname;
      return fetch(config.cartChangeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
        .then(function (result) {
          if (result.ok) Cart.applySections(result.json.sections);
          return result;
        });
    }
  };

  /* ---------- Product recommendations ---------- */
  var Recommendations = {
    load: function (root) {
      $$('[data-recommendations]:not([data-loaded])', root || document).forEach(function (el) {
        var productId = el.getAttribute('data-product-id');
        if (!productId) return;
        el.setAttribute('data-loaded', 'true');
        var url = config.recommendationsUrl + '?section_id=product-recommendations&product_id=' + encodeURIComponent(productId) +
          '&limit=' + encodeURIComponent(el.getAttribute('data-limit') || '3') + '&intent=related';
        fetch(url)
          .then(function (res) { return res.ok ? res.text() : ''; })
          .then(function (html) {
            if (!html) return;
            var results = $('[data-recommendations-results]', parseHTML(html));
            if (results) el.appendChild(results);
          })
          .catch(function () {});
      });
    }
  };

  /* ---------- Product page ---------- */
  function initProduct() {
    var section = $('[data-product]');
    var dataEl = $('[data-product-json]');
    if (!section || !dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form = $('[data-product-form]', section);
    var idInput = $('[data-variant-id-input]', form);
    var optionInputs = $$('[data-option-input]', form);
    var priceEl = $('[data-product-price]', section);
    var addButton = $('[data-add-to-cart]', form);
    var addLabel = $('[data-add-to-cart-label]', form);
    var stickyBar = $('[data-sticky-add-to-cart]', section);
    var stickyButton = $('[data-sticky-add-button]', section);
    var stickyLabel = $('[data-sticky-add-label]', section);
    var errorEl = $('[data-product-error]', section);
    var quantityInput = $('[data-quantity-input]', form);
    var gallery = initGallery(section);
    initGalleryZoom(section);

    // Per-item order limit comes from the quantity input's max attribute (snippets/order-limit.liquid).
    var perItemLimit = quantityInput && quantityInput.max ? parseInt(quantityInput.max, 10) : Infinity;
    if (isNaN(perItemLimit) || perItemLimit < 1) perItemLimit = Infinity;

    function showError(message, isNotice) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.classList.toggle('form-message--notice', !!isNotice);
      errorEl.classList.toggle('form-message--error', !isNotice);
      errorEl.hidden = false;
    }
    function hideError() {
      if (errorEl) errorEl.hidden = true;
    }
    function limitMessage(added) {
      var base = 'Limited to ' + perItemLimit + ' per customer.';
      if (added === 0) return base + ' You already have the maximum in your cart.';
      if (added > 0) return base + ' Only ' + added + ' more ' + (added === 1 ? 'was' : 'were') + ' added.';
      return base;
    }

    function selectedOptions() {
      return data.options.map(function (_, index) {
        var checked = form.querySelector('input[name="option' + (index + 1) + '"]:checked');
        return checked ? checked.value : null;
      });
    }

    function matches(variant, options, overrideIndex, overrideValue) {
      return variant.options.every(function (value, index) {
        if (index === overrideIndex) return value === overrideValue;
        return options[index] === null || value === options[index];
      });
    }

    function findVariant(options) {
      for (var i = 0; i < data.variants.length; i++) {
        if (matches(data.variants[i], options, -1, null)) return data.variants[i];
      }
      return null;
    }

    function updateAvailability(options) {
      optionInputs.forEach(function (input) {
        var index = parseInt(input.name.replace('option', ''), 10) - 1;
        var available = data.variants.some(function (variant) {
          return variant.available && matches(variant, options, index, input.value);
        });
        input.classList.toggle('is-unavailable', !available);
      });
    }

    function setButtons(enabled, label) {
      [addButton, stickyButton].forEach(function (button) { if (button) button.disabled = !enabled; });
      [addLabel, stickyLabel].forEach(function (el) { if (el) el.textContent = label; });
    }

    function renderPrice(variant) {
      if (!priceEl) return;
      var price = $('.price', priceEl);
      if (!price) return;
      price.classList.toggle('price--sale', !!variant.compare_at_price_formatted);
      var compare = $('.price__compare', price);
      if (variant.compare_at_price_formatted) {
        if (!compare) {
          compare = document.createElement('s');
          compare.className = 'price__compare';
          price.insertBefore(compare, price.firstChild);
          price.insertBefore(document.createTextNode(' '), compare.nextSibling);
        }
        compare.textContent = variant.compare_at_price_formatted;
      } else if (compare) {
        compare.remove();
      }
      var current = $('.price__current', price);
      if (current) current.textContent = variant.price_formatted;
    }

    function render(variant) {
      if (!variant) {
        idInput.value = '';
        setButtons(false, 'Unavailable');
        return;
      }
      idInput.value = variant.id;
      renderPrice(variant);
      setButtons(variant.available, variant.available ? 'Add to Cart' : 'Sold Out');
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (variant.media_id && gallery) gallery.showMedia(variant.media_id);
    }

    function onOptionChange() {
      hideError();
      var options = selectedOptions();
      updateAvailability(options);
      render(findVariant(options));
    }

    optionInputs.forEach(function (input) { input.addEventListener('change', onOptionChange); });
    if (optionInputs.length) updateAvailability(selectedOptions());

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      hideError();
      if (!idInput.value) { showError('Please select an option.'); return; }
      if (addButton.disabled) return;

      var variantId = idInput.value;
      var productId = section.getAttribute('data-product-id');
      var quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;
      var alreadyInCart = Cart.productQuantity(productId); // all sizes of this product together
      var notice = '';

      // Per-product limit: refuse when the cart already holds the maximum, trim the request otherwise.
      if (alreadyInCart >= perItemLimit) { showError(limitMessage(0)); return; }
      if (alreadyInCart + quantity > perItemLimit) {
        quantity = perItemLimit - alreadyInCart;
        notice = limitMessage(quantity);
      }

      var formData = new FormData(form);
      formData.delete('option1'); formData.delete('option2'); formData.delete('option3');
      formData.set('quantity', String(quantity));
      formData.append('sections', 'cart-drawer,cart-count');
      formData.append('sections_url', window.location.pathname);

      addButton.classList.add('is-loading');
      addButton.setAttribute('aria-busy', 'true');

      fetch(config.cartAddUrl, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
        .then(function (result) {
          if (!result.ok) {
            // Shopify may still have added part of the quantity: resync the cart, never show its message.
            return Cart.refreshSections(['cart-drawer', 'cart-count']).then(function () {
              if (Cart.productQuantity(productId) > alreadyInCart) Cart.openDrawer(variantId);
              showError(friendlyCartError(result.json, 'Could not add this item to your cart. Please try again.'));
            });
          }
          Cart.applySections(result.json.sections);
          var productTotal = Cart.productQuantity(productId);
          var lineQuantity = parseInt(result.json.quantity, 10) || 0;
          if (productTotal > perItemLimit && result.json.key) {
            // The cart changed elsewhere (another tab): trim the line just added by the excess.
            var trimmedQuantity = Math.max(0, lineQuantity - (productTotal - perItemLimit));
            return Cart.change({ id: result.json.key, quantity: trimmedQuantity }, 'cart-drawer,cart-count').then(function () {
              if (trimmedQuantity > 0) Cart.openDrawer(variantId);
              showError(limitMessage(trimmedQuantity > 0 ? -1 : 0), true);
            });
          }
          Cart.openDrawer(variantId);
          if (notice) showError(notice, true);
        })
        .catch(function () { showError('Something went wrong. Please try again.'); })
        .then(function () {
          addButton.classList.remove('is-loading');
          addButton.removeAttribute('aria-busy');
        });
    });

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else addButton.click();
      });
    }

    if (stickyBar && addButton && 'IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', scrolledPast);
        stickyBar.setAttribute('aria-hidden', String(!scrolledPast));
      }, { threshold: 0 });
      stickyObserver.observe(addButton);
    }

    Recommendations.load(section.parentNode);
  }

  /* ---------- Product gallery ---------- */
  function initGallery(section) {
    var gallery = $('[data-gallery]', section);
    if (!gallery) return null;
    var slidesEl = $('[data-gallery-slides]', gallery);
    var slides = $$('[data-gallery-slide]', gallery);
    var thumbs = $$('[data-gallery-thumb]', gallery);
    var prev = $('[data-gallery-prev]', gallery);
    var next = $('[data-gallery-next]', gallery);
    var desktop = window.matchMedia('(min-width: 768px)'); // must match the product layout breakpoint in theme.css
    var index = 0;

    function setActive(i) {
      index = i;
      thumbs.forEach(function (thumb, j) {
        thumb.classList.toggle('is-active', j === i);
        if (j === i) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }

    function goTo(i, behavior) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      if (desktop.matches) {
        slides[i].scrollIntoView({ behavior: behavior || 'smooth', block: 'nearest' });
      } else {
        slidesEl.scrollTo({ left: slides[i].offsetLeft - slidesEl.offsetLeft, behavior: behavior || 'smooth' });
      }
      setActive(i);
    }

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });
    thumbs.forEach(function (thumb, i) { thumb.addEventListener('click', function () { goTo(i); }); });

    if ('IntersectionObserver' in window && slides.length > 1) {
      var observer = new IntersectionObserver(function (entries) {
        if (desktop.matches) return;
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) setActive(slides.indexOf(entry.target));
        });
      }, { root: slidesEl, threshold: 0.6 });
      slides.forEach(function (slide) { observer.observe(slide); });
    }
    setActive(0);

    return {
      showMedia: function (mediaId) {
        var i = -1;
        slides.forEach(function (slide, j) { if (slide.getAttribute('data-media-id') === String(mediaId)) i = j; });
        if (i >= 0) goTo(i);
      }
    };
  }

  /* ---------- Product gallery hover zoom (mouse/trackpad only) ---------- */
  function initGalleryZoom(section) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    $$('[data-gallery-slide] .gallery__image-container[data-zoom-src]', section).forEach(function (container) {
      var image = $('.gallery__image-object', container);
      if (!image) return;
      container.classList.add('gallery__image-container--zoomable');
      var zoom = null;

      function track(event) {
        var rect = container.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        var x = ((event.clientX - rect.left) / rect.width) * 100;
        var y = ((event.clientY - rect.top) / rect.height) * 100;
        container.style.setProperty('--zoom-x', Math.max(0, Math.min(100, x)).toFixed(2) + '%');
        container.style.setProperty('--zoom-y', Math.max(0, Math.min(100, y)).toFixed(2) + '%');
      }

      container.addEventListener('mouseenter', function (event) {
        if (!zoom) {
          zoom = document.createElement('img');
          zoom.className = 'gallery__zoom';
          zoom.alt = '';
          zoom.setAttribute('aria-hidden', 'true');
          zoom.decoding = 'async';
          zoom.addEventListener('load', function () { zoom.classList.add('is-loaded'); });
          zoom.src = container.getAttribute('data-zoom-src');
          container.appendChild(zoom);
        }
        track(event);
        container.classList.add('is-zoomed');
      });
      container.addEventListener('mousemove', track);
      container.addEventListener('mouseleave', function () { container.classList.remove('is-zoomed'); });
    });
  }

  /* ---------- Cart page ---------- */
  function initCartPage() {
    if (!$('[data-cart-items]')) return;
    var busy = false;

    function setLoading(state) {
      var cart = $('[data-cart-items]');
      if (!cart) return;
      cart.classList.toggle('is-loading', state);
      if (state) cart.setAttribute('aria-busy', 'true'); else cart.removeAttribute('aria-busy');
    }

    function showCartError(message, isNotice, offerFix) {
      var error = $('[data-cart-error]');
      if (!error) return;
      error.textContent = message;
      if (offerFix) {
        var fix = document.createElement('button');
        fix.type = 'button';
        fix.className = 'link-button form-message__action';
        fix.setAttribute('data-cart-fix', '');
        fix.textContent = 'Reduce my cart to the limit';
        error.appendChild(fix);
      }
      error.classList.toggle('form-message--notice', !!isNotice);
      error.classList.toggle('form-message--error', !isNotice);
      error.hidden = false;
      if (!isNotice && error.focus) error.focus();
    }

    function cartLimit() {
      var anyInput = $('[data-cart-items] [data-quantity-input]');
      var limit = anyInput && anyInput.max ? parseInt(anyInput.max, 10) : Infinity;
      return isFinite(limit) && limit > 0 ? limit : Infinity;
    }

    // Per-product limit (all variants together). Shopify rejects every cart change that leaves a product
    // over the limit, so an over-limit cart (e.g. built before the rule) needs a one-request fix.
    function checkLimits() {
      var limit = cartLimit();
      if (!isFinite(limit)) return;
      var totals = {};
      $$('[data-cart-items] [data-cart-item]').forEach(function (item) {
        var productId = item.getAttribute('data-product-id');
        var input = $('[data-quantity-input]', item);
        if (!totals[productId]) totals[productId] = { quantity: 0, title: item.getAttribute('data-product-title') || 'this item' };
        totals[productId].quantity += input ? parseInt(input.value, 10) || 0 : 0;
      });
      var over = Object.keys(totals).filter(function (id) { return totals[id].quantity > limit; })
        .map(function (id) { return totals[id].title; });
      if (over.length) showCartError('Limited to ' + limit + ' per customer. Please reduce: ' + over.join(', ') + '.', true, true);
    }

    // Trim every product to the limit in one /cart/update request (first lines keep their quantity).
    function fixCart() {
      if (busy) return;
      var limit = cartLimit();
      if (!isFinite(limit)) return;
      var remaining = {};
      var updates = {};
      $$('[data-cart-items] [data-cart-item]').forEach(function (item) {
        var productId = item.getAttribute('data-product-id');
        var key = item.getAttribute('data-key');
        var input = $('[data-quantity-input]', item);
        var quantity = input ? parseInt(input.value, 10) || 0 : 0;
        if (remaining[productId] === undefined) remaining[productId] = limit;
        var allowed = Math.min(quantity, remaining[productId]);
        remaining[productId] -= allowed;
        if (allowed !== quantity) updates[key] = allowed;
      });
      if (!Object.keys(updates).length) return;
      busy = true;
      setLoading(true);
      fetch(config.cartUpdateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates, sections: 'cart-items,cart-count,cart-drawer', sections_url: window.location.pathname })
      })
        .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
        .then(function (result) {
          if (!result.ok) {
            return Cart.refreshSections(['cart-items', 'cart-count', 'cart-drawer']).then(function () {
              showCartError(friendlyCartError(result.json, 'Could not update your cart. Please try again.'));
            });
          }
          Cart.applySections(result.json.sections);
          checkLimits();
        })
        .catch(function () { showCartError('Could not update your cart. Please try again.'); })
        .then(function () { busy = false; setLoading(false); });
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-cart-fix]')) return;
      event.preventDefault();
      fixCart();
    });

    checkLimits();

    function updateLine(line, quantity) {
      if (busy) return;
      busy = true;
      setLoading(true);
      Cart.change({ line: Number(line), quantity: Number(quantity) }, 'cart-items,cart-count,cart-drawer')
        .then(function (result) {
          if (!result.ok) {
            // Resync with the real cart and show the theme's own message.
            // If the order-limit validation refused the change, offer the one-click fix.
            return Cart.refreshSections(['cart-items', 'cart-count', 'cart-drawer']).then(function () {
              var message = friendlyCartError(result.json, 'Could not update your cart. Please try again.');
              var isLimit = /^Limited to/.test(message);
              showCartError(message, isLimit, isLimit);
            });
          }
          if (result.json.item_count === 0) {
            var recs = $('.cart-recommendations');
            if (recs) recs.remove();
          }
          checkLimits();
        })
        .catch(function () { showCartError('Could not update your cart. Please try again.'); })
        .then(function () { busy = false; setLoading(false); });
    }

    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cart-items] [data-quantity-input]');
      if (!input) return;
      var value = parseInt(input.value, 10);
      if (isNaN(value) || value < 0) value = 0;
      var max = input.max ? parseInt(input.max, 10) : Infinity;
      if (value > max) { value = max; input.value = String(max); }
      updateLine(input.getAttribute('data-line'), value);
    });

    document.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-cart-remove]');
      if (!remove) return;
      event.preventDefault();
      updateLine(remove.getAttribute('data-line'), 0);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.hasAttribute('data-cart-form')) return;
      var checkout = $('[data-checkout-button]', form);
      if (checkout) { checkout.classList.add('is-loading'); checkout.setAttribute('aria-busy', 'true'); }
    });
  }

  /* ---------- Address forms: country -> province select ---------- */
  function initAddressForms() {
    $$('[data-country-select]').forEach(function (country) {
      var province = document.getElementById(country.getAttribute('data-province-target'));
      if (!province) return;
      var wrapper = province.closest('[data-province-wrapper]');
      var defaultCountry = country.getAttribute('data-default');
      var defaultProvince = province.getAttribute('data-default');
      if (defaultCountry) country.value = defaultCountry;

      function populate() {
        var option = country.options[country.selectedIndex];
        var provinces = [];
        try { provinces = JSON.parse(option.getAttribute('data-provinces') || '[]'); } catch (e) { provinces = []; }
        province.innerHTML = '';
        if (!provinces.length) { if (wrapper) wrapper.hidden = true; return; }
        provinces.forEach(function (pair) {
          var opt = document.createElement('option');
          opt.value = pair[0];
          opt.textContent = pair[1];
          province.appendChild(opt);
        });
        if (wrapper) wrapper.hidden = false;
        if (defaultProvince) province.value = defaultProvince;
      }
      country.addEventListener('change', populate);
      populate();
    });
  }

  /* ---------- YouTube channel card (footer): live data only when an API key is set in the snippet ---------- */
  function compactNumber(value) {
    var n = parseInt(value, 10);
    if (isNaN(n)) return '';
    if (n >= 1e6) return (n / 1e6).toFixed(n >= 1e7 ? 0 : 1).replace(/\.0$/, '') + 'M';
    if (n >= 1e3) return (n / 1e3).toFixed(n >= 1e4 ? 0 : 1).replace(/\.0$/, '') + 'K';
    return String(n);
  }

  function initYouTubeCard() {
    var card = $('[data-creator-card="youtube"][data-api-key]');
    if (!card) return;
    var channelId = card.getAttribute('data-channel-id');
    var apiKey = card.getAttribute('data-api-key');
    var storageKey = 'yt-card:' + channelId;
    var maxAge = 24 * 60 * 60 * 1000;

    function render(data) {
      var subscribers = $('[data-creator-count]', card);
      var label = card.getAttribute('data-count-label') || 'subscribers';
      if (subscribers && data.subscribers) { subscribers.textContent = data.subscribers + ' ' + label; subscribers.hidden = false; }
      var title = $('[data-creator-title]', card);
      if (title && data.title) title.textContent = data.title;
      var avatar = $('[data-creator-avatar]', card);
      if (avatar && data.avatar) avatar.src = data.avatar;
    }

    function load() {
      try {
        var cached = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
        if (cached && cached.data && Date.now() - cached.at < maxAge) { render(cached.data); return; }
      } catch (e) { /* storage unavailable: fetch every time */ }
      fetch('https://www.googleapis.com/youtube/v3/channels?part=snippet,statistics&id=' + encodeURIComponent(channelId) + '&key=' + encodeURIComponent(apiKey))
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (json) {
          var channel = json && json.items && json.items[0];
          if (!channel) return;
          var thumbs = (channel.snippet && channel.snippet.thumbnails) || {};
          var data = {
            title: channel.snippet && channel.snippet.title,
            avatar: (thumbs.medium || thumbs.default || {}).url,
            subscribers: channel.statistics && !channel.statistics.hiddenSubscriberCount ? compactNumber(channel.statistics.subscriberCount) : ''
          };
          render(data);
          try { window.localStorage.setItem(storageKey, JSON.stringify({ at: Date.now(), data: data })); } catch (e) { /* ignore */ }
        })
        .catch(function () { /* keep the static content */ });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) { observer.disconnect(); load(); }
      });
      observer.observe(card);
    } else {
      load();
    }
  }

  /* ---------- Focus server-rendered form messages ---------- */
  function initAutofocus() {
    var el = $('[data-autofocus]');
    if (el && !Overlay.stack.length) el.focus({ preventScroll: false });
  }

  /* ---------- Boot ---------- */
  function boot() {
    initOverlays();
    initDropdowns();
    initAccordions();
    initToggles();
    initQuantity();
    initProduct();
    initCartPage();
    initAddressForms();
    initAutofocus();
    initYouTubeCard();
    Recommendations.load(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Back/forward cache: the cart may have changed on another page.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) Cart.refreshSections(['cart-count']);
  });
})();
